import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Instructions = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
        <SafeIcon icon={FiIcons.FiHelpCircle} className="mr-2 text-blue-600" />
        Instructions
      </h2>
      <div className="space-y-4">
        <div className="rounded-lg bg-blue-50 p-4">
          <h3 className="font-bold text-blue-800 mb-2 flex items-center">
            <SafeIcon icon={FiIcons.FiVideo} className="mr-2" />
            How to Record a Shipment Video
          </h3>
          <ol className="list-decimal pl-5 space-y-2">
            <li>Scan the AWB barcode in the first input box to start recording</li>
            <li>The recording will begin automatically with the camera</li>
            <li>When finished, scan the <strong>same AWB</strong> in the second input box</li>
            <li>The video will automatically download with the AWB as the filename</li>
          </ol>
        </div>

        <div className="rounded-lg bg-green-50 p-4">
          <h3 className="font-bold text-green-800 mb-2 flex items-center">
            <SafeIcon icon={FiIcons.FiCheckSquare} className="mr-2" />
            Using Barcode Scanners
          </h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>This application works with any barcode scanner that acts as a keyboard</li>
            <li>Most USB barcode scanners will work automatically</li>
            <li>Make sure your scanner is configured to send an Enter key after scanning</li>
            <li>For testing without a scanner, you can type the AWB and press Enter</li>
          </ul>
        </div>

        <div className="rounded-lg bg-yellow-50 p-4">
          <h3 className="font-bold text-yellow-800 mb-2 flex items-center">
            <SafeIcon icon={FiIcons.FiAlertCircle} className="mr-2" />
            Important Notes
          </h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>You must allow camera permissions when prompted by your browser</li>
            <li>Videos are saved in WebM format which works in most modern media players</li>
            <li>The same AWB must be used to start and stop a recording</li>
            <li>Each video includes a watermark with date, time and "Powered by ShareMyImage.com"</li>
            <li>Voice prompts announce when recording starts and stops</li>
            <li>Video will be available for next 6 month in the cloud</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Instructions;